import React from 'react';
import { useDispatch } from 'react-redux';
import Dim from 'web/components/common/modal/common/Dim';
import GoSellingPage from 'shared/components/selling/GoSellingPage';
import { initModal } from 'shared/actions/modal.action';
import { getVideoStatusReset } from 'shared/actions/coupon.action';

function GoSellingPageContainer({ history }) {
  const dispatch = useDispatch();

  const goSellingPage = () => {
    history.push('/');
    dispatch(getVideoStatusReset());
    handleClose();
  };

  const handleClose = () => {
    dispatch(initModal());
  };
  return (
    <Dim>
      <GoSellingPage goSellingPage={goSellingPage} />
    </Dim>
  );
}

export default GoSellingPageContainer;
